import { HttpClient } from '@/shared/lib/http-client';

export const fetchSummaryStatistics = async () => {
  const response = await HttpClient.get('/statistic/summary');

  return response.data?.data;
};
